import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;

export function useProductRatings() {
  const [ratings, setRatings] = useState(() => (cache && !(cache instanceof Promise) ? cache : {}));
  useEffect(() => {
    if (!cache) cache = api.get("/reviews/product-ratings").then(({ data }) => (cache = data)).catch(() => (cache = {}));
    Promise.resolve(cache).then((d) => setRatings(d || {}));
  }, []);
  return ratings;
}
